let loadingBar = null,
  productPersonalizer,
  productPersonalizerBtn,
  checkboxItem,
  removeBgUploaderClasses = ["pplr-foto", "pplr-_foto"],
  uploadingMessage = "Dit is een preview. Onze designers plaatsen deze foto op de kaart.",
  height = 0,
  width = 0,
  imageMaxSize = "The uploaded image exceeds the size limit, maximum 6250 x 4000 px",
  fakeImageFile = "Uploaded file has an image extension, but is not an image",
  noConnection = "Couldn't connect to background removal, please try again at another time, or have background removed after purchase",
  intervalId = null,
  BACKGROUND_REMOVAL_LIMIT = 2,
  SESSION_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds

window.addEventListener("load", function () {
  console.log("Remove BG RAN");
  (productPersonalizer = document.querySelector(".product-personalizer")),
    (productPersonalizerBtn = productPersonalizer.querySelector(".pplr-c-button")),
    productPersonalizerBtn !== null &&
      productPersonalizerBtn.addEventListener("click", (e) => {
        setTimeout(() => {
          attachRemoveBgEvent();
        }, 400);
      }),
    attachRemoveBgEvent();
  
  // Initialize or check session on page load
  initializeSession();
});

function initializeSession() {
  const sessionData = JSON.parse(localStorage.getItem('backgroundRemovalSession') || '{}');
  const currentTime = new Date().getTime();

  // Check if session has expired
  if (!sessionData.startTime || (currentTime - sessionData.startTime > SESSION_DURATION)) {
    // Reset session
    localStorage.setItem('backgroundRemovalSession', JSON.stringify({
      startTime: currentTime,
      removalCount: 0
    }));
  }
}

const attachRemoveBgEvent = () => {
  const input = document.getElementsByTagName("input");
  for (var i = 0; i < input.length; i++) {
    let htmlItem = input[i];
    const pplrWrapper = htmlItem.parentElement.parentElement;
    if (
      input[i].type == "file" &&
      input[i].classList.contains("fileupload") &&
      input[i].classList.contains("pplr_monogram") &&
      removeBgUploaderClasses.some(className => pplrWrapper.classList.contains(className)) &&
      !pplrWrapper.classList.contains("p_h_d_p")
    ) {
      input[i].addEventListener("input", removeBackground);
      let newAccept = htmlItem.accept;
      newAccept = newAccept.replace(",image/svg+xml", ""),
      htmlItem.accept = newAccept;
    }
  }
};

async function removeBackground(e) {
  // Check session and removal limit
  const sessionData = JSON.parse(localStorage.getItem('backgroundRemovalSession') || '{}');
  const currentTime = new Date().getTime();

  // Check if session has expired
  if (!sessionData.startTime || (currentTime - sessionData.startTime > SESSION_DURATION)) {
    initializeSession();
    sessionData.removalCount = 0;
  }

  // Check removal count
  if (sessionData.removalCount >= BACKGROUND_REMOVAL_LIMIT) {
    alert(`Session background removal limit reached. Please retry in 15 minutes.`);
    return;
  }

  if (
    ((file = e.target.files[0]),
    (files = e.target),
    (checkboxItem = files.parentElement.parentElement.querySelector(
      ".remove-bg-checkbox"
    )),
    checkboxItem != null &&
      (console.log("Checkbox item found"),
      console.log(checkboxItem.checked),
      !checkboxItem.checked))
  )
    return;

  let result = "";
  if (
    ((e.target.value = ""),
    console.log(file),
    file.name.toLowerCase().includes(".heic") ||
      file.name.toLowerCase().includes(".heif") ||
      file.name.toLowerCase().includes(".webp") ||
      file.name.toLowerCase().includes(".svg"))
  ) {
    alert(
      "The file format is not supported. Only PNG and JPG formats are supported for background remove."
    );
    return;
  }

  if (
    ((height = 0),
    (width = 0),
    await checkImage(file),
    width > 6e3 || height > 6e3)
  ) {
    alert(imageMaxSize);
    return;
  } else if (width == 0 || height == 0) {
    alert(fakeImageFile);
    return;
  } else if (width < 200 || height < 200) {
    alert(imageMinSize);
    return;
  }

  const formData = new FormData();
  console.log(formData),
    formData.append("image_file", file),
    formData.append("size", "full");
    let apiKey = "BihZMiJqEMhCEVsbpPYs43Mp",
    postUrl = "https://api.remove.bg/v1.0/removebg";
  removeProgressBar(e, !0),
    fetch(postUrl, {
      method: "POST",
      headers: { "X-Api-Key": apiKey },
      body: formData,
    })
      .then((response) => {
        if (response.status != 200) {
          throw (
            (alert(
              "Images must have a subject that is clearly meant to be the foreground, such as a person, animal, product or car."
            ),
            console.error("Error:", response.status, response.statusText),
            new Error("Error:", response.status, response.statusText))
          );
          removeProgressBar(e, !1);
        }
        return response.blob();
      })
      .then((finalResponse) => {
        removeProgressBar(e, !1), renderBgRemovedImage(finalResponse, e);
        
        // Update session data
        const updatedSessionData = JSON.parse(localStorage.getItem('backgroundRemovalSession') || '{}');
        updatedSessionData.removalCount = (updatedSessionData.removalCount || 0) + 1;
        localStorage.setItem('backgroundRemovalSession', JSON.stringify(updatedSessionData));
      })
      .catch(),
    console.log("Remove bg ran");
}

const removeProgressBar = (e, trueFalse) => {
    const parentElement = e.target.parentElement.parentElement;
    
    // Create paragraph element for the message
    const messageElement = document.createElement("p");
    messageElement.textContent = uploadingMessage;
    messageElement.style.textAlign = "left";
    messageElement.style.padding = "20px 0";
    messageElement.classList.add("remove-bg-message");

    const existingMessage = parentElement.querySelector(".remove-bg-message");
    
    if (trueFalse === true) {
        if (!existingMessage) {
            parentElement.querySelector(".fileupload").style.display = "none";
            parentElement.append(messageElement);
        }
    } else {
        if (existingMessage) {
            existingMessage.remove();
            parentElement.querySelector(".fileupload").style.display = "block";
        }
    }
},
  renderBgRemovedImage = (blob, e) => {
    let fileObj = new File([blob], "RemovedBackgroundImage.png", {
        type: "image/png",
        lastModified: new Date().getTime(),
      }),
      list = new DataTransfer();
    list.items.add(fileObj);
    let myFileList = list.files;
    e.target.files = myFileList;
    let event = new Event("change");
    e.target.dispatchEvent(event);
  },
  checkImage = async (file2) =>
    new Promise((resolve) => {
      var reader = new FileReader();
      reader.readAsDataURL(file2),
        (reader.onloadend = function (e) {
          var image = new Image();
          image.src = e.target.result;
          try {
            (image.onload = function () {
              (height = this.height), (width = this.width), resolve(!0);
            }),
              delay(1e3).then(() => resolve(!0));
          } catch {
            resolve(!0);
          }
        });
    });
function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
const convertHeicToPngFiles = async (blob) =>
  new Promise((resolve) => {
    heic2any({ blob })
      .then((conversionResult) => {
        resolve(conversionResult);
      })
      .catch((e) => {
        resolve(null);
      });
  });
//# sourceMappingURL=/cdn/shop/t/57/assets/eliminato.js.map?v=58253456975998568851698158930
